export const InterceptorSkipHeader = 'X-Skip-Interceptor';